import { USER_FOUND, SESSION_TERMINATED } from 'redux-oidc';
import TokenManager from "accessTokens/TokenManager";
import * as messageActions from 'actions/messageActions';

export function errorCallback() {}

const clearOidc = () => {
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);

    if (key.includes('oidc')) {
      localStorage.removeItem(key);
    }
  }
};

export const middlewareHandler = (store, next, action) => {
  next(action);

  if (action.payload && action.payload.error === "login_required") {
    console.error("Error: Failed to load " + action.key, action.payload);
    TokenManager.logout();
    return;
  }

  if (action.type === USER_FOUND) {
    // since we cant control how many USER_FOUND are triggered,
    // make sure to only trigger the action if it wasnt triggered before
    const message = store.getState().get('message');
    const started = message.get('userChannelGrantStarted');
    const finished = message.get('userChannelGrantFinished');
    if (!started && !finished) {
      const user = action.payload.profile.preferred_username;
      const token = action.payload.access_token;
      store.dispatch(messageActions.userChannelGrantStarted(user, token));
    }
  } else if (action.type === SESSION_TERMINATED) {
    clearOidc();
  }
};

export const createTokenMiddleware = () => {
  return (store) => (next) => (action) => {
    middlewareHandler(store, next, action);
  };
};



// WEBPACK FOOTER //
// ./src/store/tokenMiddleware.js